module.exports = __webpack_public_path__ + "r-v3/img/icon_video_on.dc14f956.svg";